// extracted by mini-css-extract-plugin
module.exports = {"outerBall":"pokeballbg_outerBall__13th-","midBall":"pokeballbg_midBall__10gvH","centerBall":"pokeballbg_centerBall__3AurC","rectangle":"pokeballbg_rectangle__2rOuO"};